<a *ngIf="tag" routerLink="{{tag.url | drupalUrl}}"><button mat-flat-button color="primary">{{tagHelper.idToName(tag.target_id)}}</button></a>
